<template>
    <el-table
        id="QuoteTable"
        style="width: 100%"
        max-height="500"
        :data="quotes"
        @row-click="$emit('rowClicked', $event)"
    >
        <el-table-column
            v-for="column in tableColumns"
            :key="column.label"
            :width="column.width"
            :min-width="column.minWidth"
            :prop="column.prop"
            :label="column.label"
            :sortable="column.sortable"
            :formatter="column.formatter"
            :sort-method="column.sortMethod"
            :show-overflow-tooltip="true"
        >
            <template slot="header" slot-scope="scope">
                {{ scope.column.label }}
            </template>
            <template slot-scope="props">
                <template v-if="props.column.property === 'status'">
                    <div :class="getStyleForStatus(props.row.status)">
                        {{ props.row.status }}
                    </div>
                </template>
                <template v-else-if="props.column.formatter">
                    {{ props.column.formatter(props.row) }}
                </template>
                <template v-else>
                    {{ getProp(props.row, props.column.property) }}
                </template>
            </template>
        </el-table-column>
    </el-table>
</template>
<script>
import { DatePicker } from "element-ui";
import _ from "lodash";
import moment from "moment-timezone";

export default {
    name: "QuotesTable",
    components: {
        [DatePicker.name]: DatePicker,
    },
    props: {
        quotes: {
            type: Array,
            required: true,
        },
        excludeColumns: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        tableColumns() {
            let columns = [
                {
                    prop: "id",
                    label: "Quote No.",
                    sortable: true,
                    width: 125,
                },
                {
                    prop: "customer.name",
                    label: "Customer",
                    width: 300,
                },
                {
                    prop: "locationName",
                    label: "Location",
                    width: 300,
                },

                {
                    prop: "estimatedReceiptDate",
                    label: "Est. Receipt Date",
                    sortable: true,
                    sortMethod: (a, b) =>
                        new Date(b.estimatedReceiptDate) -
                        new Date(a.estimatedReceiptDate),
                    formatter: (row) =>
                        this.formatDate(row.estimatedReceiptDate),
                    width: 175,
                },
                {
                    prop: "estimatedDeliveryDate",
                    label: "Est. Delivery Date",
                    sortable: true,
                    // eslint-disable-next-line max-len
                    sortMethod: (a, b) =>
                        new Date(b.estimatedDeliveryDate) -
                        new Date(a.estimatedDeliveryDate),
                    formatter: (row) =>
                        this.formatDate(row.estimatedDeliveryDate),
                    width: 175,
                },
                {
                    prop: "status",
                    label: "Status",
                    sortable: true,
                    minWidth: 100,
                },
                {
                    prop: "date",
                    label: "Created",
                    formatter: (row) => this.formatDate(row.date),
                    sortable: true,
                    sortMethod: (a, b) => new Date(b.date) - new Date(a.date),
                    width: 125,
                },
                {
                    prop: "notes",
                    label: "Notes",
                    width: 500,
                },
            ];
            // eslint-disable-next-line max-len
            columns = columns.filter(
                (column) =>
                    this.excludeColumns.findIndex(
                        (hide) => hide === column.label,
                    ) === -1,
            );
            return columns;
        },
    },
    methods: {
        getProp(object, property) {
            return _.get(object, property);
        },
        getStyleForStatus(status) {
            if (!status) return "denied";
            return [status.toLowerCase(), "statusLabel"];
        },
        formatDate(date) {
            if (date) {
                return moment(date).format("MM/DD/YYYY");
            }
            return "--";
        },
    },
};
</script>
